<div id="storage" class="printMe" *ngIf="displaySaviIconFlags$ | async as displaySaviIconFlags">
  <div *ngIf="report" style="width:22cm;display:block;flex-direction: column;box-sizing:border-box;"
    class="report-gm-default-font one-page-report"
    [class.one-page-report-compact]="hasOptionalTireSections(inspectionService.report?.categories)">
    <div style="margin-top:8px;background-color:white;">
      <div fxLayout="row" id="header">
        <div id="inspectionInfo" fxLayout="column" style="width:30%;" fxLayoutAlign="start start">
          <span>{{inspectionService.report?.header?.title}}</span>
          <span>{{inspectionService.report?.header?.CustomerName}}</span>
          <span>{{inspectionService.report?.header?.date}}</span>
          <span>Service Advisor: {{inspectionService.report?.header?.AdvisorName}}</span>
        </div>
        <div id="vehicleInfo" fxLayout="column" fxLayoutAlign="start start" style="width:30%;">
          <span>{{inspectionService.report?.header?.VehicleYear}}
            {{inspectionService.report?.header?.VehicleModel}}</span>
          <span>Repair Order: {{inspectionService.report?.header?.WorkOrderId}}</span>
          <span>Tag: {{inspectionService.report?.header?.tag}}</span>
          <span>VIN: {{inspectionService.report?.header?.Vin}}</span>
        </div>
        <div fxLayout="column" fxLayoutAlign="end end" style="width:40%">
          <img class="dealership-logo" [src]="inspectionService?.dealershipLogo" alt="Logo" crossOrigin>
        </div>
      </div>
      <div fxLayout="row" style="border:1px solid lightgray;margin-top:8px;padding:2px;width:100%;">
        <div fxLayout="row" style="width:170px">
          <div fxLayout="column">
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color: #00C853; margin: 0 1px 0 0">
              check_circle</mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Checked and OK</span>
          </div>
        </div>
        <div fxLayout="row" style="width:220px">
          <div>
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color:#FFD600; margin:0 2px 0 0">
              warning</mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Future Attention Requried</span>
          </div>
        </div>
        <div fxLayout="row" style="width:170px">
          <div fxLayout="column">
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color:#D50000; margin:0 2px 0 0">report
            </mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Repair Required</span>
          </div>
        </div>
        <div fxLayout="row">
          <div fxLayout="column">
            <mat-icon mat-font-set="material-icons" class="gm-mat-icon" style="color:#000000;margin:0 2px 0 0">remove
            </mat-icon>
          </div>
          <div fxLayout="column">
            <span style="padding-top:2px">Not Inspected</span>
          </div>
        </div>
      </div>
      <div fxLayout="row" id="reportBody">
        <div fxLayout="column" style="width:33%;margin-right:12px;">
          <div id="engineOilFilter">
            <span
              class="report-section-title">ENGINE
              OIL & FILTER</span>
            <div *ngFor="let task of inspectionService.report?.categories?.OilLife?.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div *ngIf="task?.displayOilLife == 0" fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div *ngIf="task?.displayOilLife == 0" fxLayout="column" style="padding:2px">
                <span>{{task?.TaskName}}</span>
              </div>
              <div *ngIf="task?.displayOilLife == 1" style="padding:4px; width:100%">
                <div fxLayout="row" style="width:100%" fxflex fxLayoutAlign="space-between center">
                  <div class="flex flex-row">
                    <span>{{task?.TaskName}}</span>
                    <div class="flex items-center"
                      *ngIf="inspectionService.displaySaviIcon(displaySaviIconFlags, task) | async as displaySaviIcon">
                      <img *ngIf="displaySaviIcon" class="pl-1 h-2.5 w-auto" src="assets/savi-icon.png" alt="...">
                    </div>
                  </div>
                  <span *ngIf="task?.color !== 'Grey'">{{task?.oilLife}}%</span>
                  <span *ngIf="task?.color === 'Grey'">N/A</span>
                </div>
              </div>
            </div>
          </div>
          <div id="lights">
            <span
              class="report-section-title">LIGHTS</span>
            <div *ngFor="let task of inspectionService.report?.categories?.CheckLights?.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div fxLayout="column" style="padding:2px">
                <span>{{task?.TaskName}}</span>
              </div>
            </div>
          </div>
          <div id="windshieldWipers">
            <span
              class="report-section-title">WINDSHIELD
              & WIPERS</span>
            <div *ngFor="let task of inspectionService.report?.categories?.WindshieldWipers?.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div fxLayout="column" style="padding:2px">
                <span>{{task?.TaskName}}</span>
              </div>
            </div>
          </div>
          <div id="checkBattery">
            <span
              class="report-section-title">BATTERY</span>
            <div *ngFor="let task of inspectionService.report?.categories?.CheckBattery?.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div *ngIf="task?.displayBatteryVoltage == 0" fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div *ngIf="task?.displayBatteryVoltage == 0" fxLayout="column" style="padding:2px">
                <span>{{task?.TaskName}}</span>
              </div>
              <div
                *ngIf="task?.displayBatteryVoltage == 1 && inspectionService.report?.header?.title !== 'GM Express Inspection'"
                style="padding:4px;width:100%;">
                <div fxLayout="row" style="width:100%" fxFlex fxLayoutAlign="space-between center">
                  <span>{{task?.TaskName}}</span>
                  <span>{{task?.batteryVoltage}}v</span>
                </div>
              </div>
            </div>
          </div>
          <div id="systemFluidLeakInspection">
            <span
              class="report-section-title">SYSTEMS,
              FLUIDS
              & VISIBLE LEAK INSPECTION</span>
            <div *ngFor="let task of inspectionService.report?.categories?.CheckFluidLevels?.tasks | orderBy: 'sequence'"
              fxLayout="row">
              <div fxLayout="column">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                  style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                  style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                  style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
              </div>
              <div fxLayout="row" style="padding:2px;width:100%;" fxLayoutAlign="space-between">
                <span>{{task?.TaskName}}</span>
                <span *ngIf="task?.fluidFilled == true">Filled</span>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="column">
          <div id="tireSection">
            <span
              class="report-section-title report-section-title-padded">TIRE
              INSPECTION</span>
            <div class="flex flex-row w-full h-6 items-center"
              style="justify-content: space-around; background:rgba(233, 230, 230, 0.897); width: 100%;border-right: 1px solid lightgray;border-left: 1px solid lightgray;">
              <div class="flex flex-row justify-center items-center">Tread depth</div>
              <div class="flex flex-row justify-center items-center">
                <mat-icon class='mr-1' mat-font-set="material-icons" class="gm-mat-icon"
                  style="color:#00C853; margin:0 2px 0 0">
                  check_circle</mat-icon>
                <span>{{inspectionService.treadDepthSettings?.greenTreadDepth}}/32 or greater</span>
              </div>
              <div class="flex flex-row justify-center items-center">
                <mat-icon class='mr-1' mat-font-set="material-icons" class="gm-mat-icon"
                  style="color:#FFD600; margin: 0 2px 0 0">
                  warning</mat-icon>
                <span>{{inspectionService.treadDepthSettings.yellowTreadDepth}}/32 to
                  {{inspectionService.treadDepthSettings?.greenTreadDepth-1}}/32</span>
              </div>
              <div class="flex flex-row justify-center items-center">
                <mat-icon class='mr-1' mat-font-set="material-icons" class="gm-mat-icon"
                  style="color:#D50000; margin: 0 2px 0 0">
                  report</mat-icon>
                <span>{{inspectionService.treadDepthSettings?.yellowTreadDepth-1}}/32 or less</span>
              </div>
            </div>
            <div fxLayout="row" style="border:1px solid lightgray; background:rgba(233, 230, 230, 0.897)">
              <div fxLayout="column" style="width:50%;border-right:1px solid darkgray">
                <div id="driverFront" fxLayout="column" class="tire-card">
                  <div fxLayout="row">
                    <span>Driver Front</span>
                    <div class="h-full flex items-center"
                      *ngIf="inspectionService.displaySaviIcon(displaySaviIconFlags, inspectionService?.inspection?.tires[0]?.tasks[0]) | async as displaySaviIcon">
                      <img *ngIf="displaySaviIcon" class="pl-1 h-2.5 w-auto" src="assets/savi-icon.png" alt="...">
                    </div>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI before</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.psiIn !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.psiIn === 0">--</span>

                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI set to</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.psiOut !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.psiOut === 0">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverFrontTire?.wearPattern}}
                  </div>
                </div>
                <div id="driverRear" fxLayout="column" class="tire-card"
                  *ngIf="!hasDualRearTireCategory(inspectionService.report?.categories)">
                  <div fxLayout="row">
                    <span>Driver Rear</span>
                    <div class="h-full flex items-center"
                      *ngIf="inspectionService.displaySaviIcon(displaySaviIconFlags, inspectionService?.inspection?.tires[0]?.tasks[1]) | async as displaySaviIcon">
                      <img *ngIf="displaySaviIcon" class="pl-1 h-2.5 w-auto" src="assets/savi-icon.png" alt="...">
                    </div>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header?.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI before</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.psiIn !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.psiIn === 0">--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI set to</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.psiOut !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks?.DriverRearTire?.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.psiOut === 0">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.DriverRearTire?.wearPattern}}
                  </div>
                </div>
                <!-- <div id="spareTire" *ngIf="!inspectionService.report?.header.expressFlag" fxLayout="column" style="margin:8px;">
                  <div fxLayout="row">
                    <span>Spare</span>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column">psi before </span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.psiIn !== 0" >{{inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.psiIn}}</span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.psiIn === 0" >--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column">psi set to </span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.psiOut !== 0" >{{inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.psiOut}}</span>
                        <span fxLayout="column" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.psiOut === 0" >--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.SpareTire.wearPattern}}
                  </div>
                </div> -->
                <div id="alignmentRotationBalance" fxLayout="column" class="tire-card">
                  <div>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Rotationneeded?.color === 'Green'"
                      style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Rotationneeded?.color === 'Red'"
                      style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Rotationneeded?.color === 'Grey'"
                      style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    <span
                      style="padding:2px">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Rotationneeded?.TaskName}}</span>
                  </div>
                  <div>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Alignmentneeded?.color === 'Green'"
                      style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Alignmentneeded?.color === 'Red'"
                      style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Alignmentneeded?.color === 'Grey'"
                      style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    <span
                      style="padding:2px">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Alignmentneeded?.TaskName}}</span>
                  </div>
                  <div>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Balanceneeded?.color === 'Green'"
                      style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Balanceneeded?.color === 'Red'"
                      style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                    <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                      *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Balanceneeded?.color === 'Grey'"
                      style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    <span
                      style="padding:2px">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Balanceneeded?.TaskName}}</span>
                  </div>
                </div>
              </div>
              <div fxLayout="column" style="width:50%">
                <div id="passengerFront" fxLayout="column" class="tire-card">
                  <div fxLayout="row">
                    <span>Passenger Front</span>
                    <div class="h-full flex items-center"
                      *ngIf="inspectionService.displaySaviIcon(displaySaviIconFlags, inspectionService?.inspection?.tires[0]?.tasks[2]) | async as displaySaviIcon">
                      <img *ngIf="displaySaviIcon" class="pl-1 h-2.5 w-auto" src="assets/savi-icon.png" alt="...">
                    </div>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header?.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI before</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.psiIn !== 0">
                          {{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.psiIn === 0">--</span>

                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI set to</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.psiOut !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.psiOut === 0"
                          style="width:30%">--</span>

                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerFrontTire?.wearPattern}}
                  </div>
                </div>
                <div id="passengerRear" fxLayout="column" class="tire-card"
                  *ngIf="!hasDualRearTireCategory(inspectionService.report?.categories)">
                  <div fxLayout="row">
                    <span>Passenger Rear</span>
                    <div class="h-full flex items-center"
                      *ngIf="inspectionService.displaySaviIcon(displaySaviIconFlags, inspectionService?.inspection?.tires[0]?.tasks[3]) | async as displaySaviIcon">
                      <img *ngIf="displaySaviIcon" class="pl-1 h-2.5 w-auto" src="assets/savi-icon.png" alt="...">
                    </div>
                  </div>
                  <div fxLayout="row" *ngIf="!inspectionService.report?.header?.expressFlag">
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI before</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.psiIn !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.psiIn}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.psiIn === 0">--</span>
                      </div>
                    </div>
                    <div fxLayout="column" style="width:50%">
                      <div fxLayout="row">
                        <span fxLayout="column" class="mr-1">PSI set to</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.psiOut !== 0">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.psiOut}}</span>
                        <span fxLayout="column"
                          *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.psiOut === 0"
                          style="width:30%">--</span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.color === 'Yellow'"
                        style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Tread Depth</span>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.treadDepth}}/32</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <span fxLayout="row">Wear pattern/damage:</span>
                  </div>
                  <div fxLayout="row" style="border-bottom:1px solid darkgray;min-height:20px">
                    {{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.PassengerRearTire?.wearPattern}}
                  </div>
                </div>
                <div id="tireOther" fxLayout="column" class="tire-card">
                  <div id="resetTirePressureMonitor" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Resettirepressuremonitor?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Resettirepressuremonitor?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Resettirepressuremonitor?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Resettirepressuremonitor?.TaskName}}</span>
                    </div>
                  </div>
                  <div id="wheelLugnutTorqueCheck" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Wheellugnuttorquecheck?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Wheellugnuttorquecheck?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Wheellugnuttorquecheck?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Wheellugnuttorquecheck?.TaskName}}</span>
                    </div>
                  </div>
                  <div id="tireBuildDates" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.TirebuilddatesDOTswithin6years?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.TirebuilddatesDOTswithin6years?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.TirebuilddatesDOTswithin6years?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.TirebuilddatesDOTswithin6years?.TaskName}}</span>
                    </div>
                  </div>
                  <!-- <div id="tireSealantExpiration" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.Tiresealantexpiration.TaskName"
                    fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.Tiresealantexpiration.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.Tiresealantexpiration.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.Tiresealantexpiration.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.Tiresealantexpiration.TaskName}}:</span>
                      <span>{{inspectionService.report?.categories?.CheckTiresandTreadDepths.tasks.Tiresealantexpiration.sealantExpirationDate}}</span>
                    </div>
                  </div> -->
                  <div id="spareTireCheck" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Sparetirechecked?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Sparetirechecked?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Sparetirechecked?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column">
                      <span
                        style="padding:2px">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Sparetirechecked?.TaskName}}</span>
                    </div>
                  </div>
                  <div id="tiresInflatedToSpecification" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Tiresinflatedtospecification?.color === 'Green'"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Tiresinflatedtospecification?.color === 'Red'"
                        style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Tiresinflatedtospecification?.color === 'Grey'"
                        style="color:#000000; margin:0 2px 0 0">remove</mat-icon>
                    </div>
                    <div fxLayout="column">
                      <span
                        style="padding:2px">{{inspectionService.report?.categories?.CheckTiresandTreadDepths?.tasks?.Tiresinflatedtospecification?.TaskName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dual-tire-section"
            *ngFor="let dualSection of getOptionalTireCategories(inspectionService.report?.categories);
              trackBy: trackByCategoryName">
            <span class="report-section-title report-section-title-padded">{{dualSection.categoryName
              | uppercase}}</span>
            <div fxLayout="column" style="border:1px solid lightgray; background:rgba(233, 230, 230, 0.897)">
              <div *ngFor="let task of dualSection.tasks" fxLayout="row" fxLayoutAlign="start center"
                class="dual-tire-row">
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task.color === 'Green'"
                  style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task.color === 'Yellow'"
                  style="color:#FFD600; margin:0 2px 0 0">warning</mat-icon>
                <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task.color === 'Red'"
                  style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                <b class="mr-1">{{task.TaskName}}:</b>
                <span>{{task.treadDepth}}/32<ng-container
                    *ngIf="!inspectionService.report?.header?.expressFlag"> &mdash; In: {{task.psiIn || '--'}}
                    // Out: {{task.psiOut || '--'}}</ng-container><ng-container *ngIf="task.wearPattern">
                    &mdash; {{task.wearPattern}}</ng-container></span>
              </div>
            </div>
          </div>
          <div id="brakes">
            <span
              class="report-section-title">BRAKES</span>
            <div fxLayout="row" style="border:1px solid lightgray; background:rgba(233, 230, 230, 0.897)">
              <div fxLayout="column" style="width:36%;border-right:1px solid darkgray">
                <div id="frontBrakes" fxLayout="column" style="margin-left:8px; margin-top:8px">
                  <div fxLayout="row">
                    <span> Front Brakes</span>
                  </div>
                  <div id="driverFrontBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverFrontBrake?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverFrontBrake?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverFrontBrake?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverFrontBrake?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Driver front
                        {{inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverFrontBrake?.brakeMeasurement}}</span>
                    </div>
                  </div>
                  <div id="passengerFrontBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerFrontBrake?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerFrontBrake?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerFrontBrake?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerFrontBrake?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Passenger front
                        {{inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerFrontBrake?.brakeMeasurement}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="column" style="width:36%;border-right:1px solid darkgray">
                <div id="rearBrakes" fxLayout="column" style="margin-left:8px;margin-top:8px">
                  <div fxLayout="row">
                    <span> Rear Brakes</span>
                  </div>
                  <div id="driverRearBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverRearBrake?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverRearBrake?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverRearBrake?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverRearBrake?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Driver rear
                        {{inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.DriverRearBrake?.brakeMeasurement}}</span>
                    </div>
                  </div>
                  <div id="passengerRearBrake" fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerRearBrake?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerRearBrake?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerRearBrake?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerRearBrake?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>Passenger rear
                        {{inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.PassengerRearBrake?.brakeMeasurement}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="column" style="width:28%">
                <div id="extraBrakes" fxLayout="column" style="margin-top:8px">
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Brakesystem?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Brakesystem?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Brakesystem?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Brakesystem?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Brakesystem?.TaskName}}</span>
                    </div>
                  </div>
                  <div fxLayout="row">
                    <div fxLayout="column">
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Parkingbrake?.color === 'Green'"
                        style="color:#00C853">check_circle</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Parkingbrake?.color === 'Yellow'"
                        style="color:#FFD600">warning</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Parkingbrake?.color === 'Red'"
                        style="color:#D50000">report</mat-icon>
                      <mat-icon mat-font-set="material-icons" class="gm-mat-icon"
                        *ngIf="inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Parkingbrake?.color === 'Grey'"
                        style="color:#000000">remove</mat-icon>
                    </div>
                    <div fxLayout="column" style="padding:2px">
                      <span>{{inspectionService.report?.categories?.CheckBrakesMeasureFrtandRearLinings?.tasks?.Parkingbrake?.TaskName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="additionalChecks">
            <span
              class="report-section-title">VISIBLE
              & FUNCTIONAL
              INSPECTIONS</span>
            <div fxLayout="row">
              <div fxLayout="column" style="width:50%">
                <span style="margin-bottom:2px;margin-top:2px">INSPECT(FIT, FORM & FUNCTION)</span>
                <div
                  *ngFor="let task of inspectionService.report?.categories?.AdditionalChecks.inspect | orderBy : 'sequence'"
                  fxLayout="row">
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                    style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                    style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                    style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                    style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
                  <span style="padding:2px">{{task?.TaskName}}</span>
                </div>
              </div>
              <div fxLayout="column" style="width:50%">
                <span style="margin-bottom:2px;margin-top:2px">CHECK OPERATION</span>
                <div
                  *ngFor="let task of inspectionService.report?.categories?.AdditionalChecks?.checkOperation | orderBy : 'sequence'"
                  fxLayout="row">
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                    style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                    style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                    style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                    style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
                  <span style="padding:2px">{{task?.TaskName}}</span>
                </div>
                <span *ngIf="inspectionService.report?.categories?.AdditionalChecks.lubricate"
                  style="margin-bottom:2px;margin-top:2px">LUBRICATE</span>
                <div
                  *ngFor="let task of inspectionService.report?.categories?.AdditionalChecks?.lubricate | orderBy : 'sequence'"
                  fxLayout="row">
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                    style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                    style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                    style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                    style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
                  <span style="padding:2px">{{task?.TaskName}}</span>
                </div>
                <span style="margin-bottom:2px;margin-top:2px">CLEAN</span>
                <div
                  *ngFor="let task of inspectionService.report?.categories?.AdditionalChecks?.clean | orderBy : 'sequence'"
                  fxLayout="row">
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Green'"
                    style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Yellow'"
                    style="color:#FFD600; margin: 0 2px 0 0">warning</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Red'"
                    style="color:#D50000; margin: 0 2px 0 0">report</mat-icon>
                  <mat-icon mat-font-set="material-icons" class="gm-mat-icon" *ngIf="task?.color === 'Grey'"
                    style="color:#000000; margin: 0 2px 0 0">remove</mat-icon>
                  <span style="padding:2px">{{task?.TaskName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class=" html2pdf__page-break"></div>-->

    <div style="page-break-before:always;margin:8px;position:relative;display:block; "
      *ngIf="inspectionService.report?.quoteLines?.length >  0" fxLayout="column">
      <div id="quoteHeader" style="margin-bottom:16px;">
        <h3 class="mat-headline" style="margin-bottom:8px;">Quote Details</h3>
        <hr class="hr-report">
      </div>
      <div id="quoteContainer">
        <div style="page-break-inside:avoid;margin-bottom:12px;position:relative;display:block;" *ngFor="let line
                            of inspectionService.report?.quoteLines | orderBy: [ 'Case']">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="column" fxLayoutAlign="center start">
              <span class="mat-subhead" style="text-decoration: underline; word-break: break-word">Case {{line?.Case}}
                - {{line?.TaskName}}</span>
              <span class="mat-caption" style="margin:2px 0px 2px 8px;">{{line?.RecommendedHours}} Labour Hours
                -
                <i>Expires {{line.ExpirationDate | moment: 'MM.DD.YYYY'}}</i>
              </span>
              <span class="mat-caption" style="margin:2px 0px 2px 8px;">Employee: {{line?.Employee}}</span>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" style="">
            <div fxFlex="65" fxLayoutAlign="start start" fxLayout="column">
              <div fxLayout="column">
                <span class="mat-body-2">
                  Concern
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word">{{line?.Note ||
                  "Not Available" }}</span>
              </div>
              <div fxLayout="column">
                <span class="mat-body-2">
                  Cause
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word">{{line?.Cause ||
                  "Not Available"}} </span>
              </div>
              <div fxLayout="column">
                <span class="mat-body-2">
                  Correction
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word;">{{line?.Recommendation
                  ||
                  "Not Available "}}</span>
              </div>
            </div>
            <div fxFlex="30" fxLayout="row wrap" fxLayoutAlign="start start" style="margin-right:8px;">
              <div fxLayout="row" fxFlex="100">
                <span class="mat-body-2">Subtotals</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px; ">
                <span class="mat-caption">Labour:</span>
                <span class="mat-caption">{{line?.labourSubTotal | currency}}</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                <span class="mat-caption">Parts:</span>
                <span class="mat-caption">{{line?.partsSubTotal | currency}}</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                <span class="mat-caption">Additional Charges:</span>
                <span class="mat-caption">{{line?.additionalCharges | currency}} </span>
              </div>
              <div fxLayout="row" fxFlex="100 " fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                <span class="mat-caption">Tax:</span>
                <span class="mat-caption">{{line?.tax | currency}}</span>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
                <span class="mat-body-2">Total:</span>
                <span class="mat-body-2">{{line?.CaseTotal| currency}}</span>
              </div>
            </div>
          </div>
          <mat-divider style="margin-top:8px;"></mat-divider>
        </div>
      </div>

      <div id="quoteTotal" fxLayout="column" fxLayoutAlign="center end" style="width:100%;">
        <span class="mat-subhead" style="font-weight:500;">Quote Total:
          {{getQuoteTotal(inspectionService.report?.quoteLines)
          | currency}} </span>
        <span class="mat-caption">*Shop supplies may apply.</span>
      </div>
    </div>

    <div *ngIf="this.inspectionService?.bodyReportObject?.signature"
      style="break-before:page;margin:8px;position:relative;display:block;">
      <inspection-body-report [printView]=true></inspection-body-report>
    </div>
  </div>
</div>